let AllowOnlyScanDirective = [
  () => {
    return {
      restrict: "A",
      require: {
        ngModel: "ngModel"
      },
      link: (scope, element, attrs, controller) => {
        let timerHandle = null;
        const DEFAULT_TIME_LIMIT = 700;
        const MAX_ALLOWED_LIMIT = 2000;
        const TIME_LIMIT = attrs.timeLimit ? Math.min(attrs.timeLimit, MAX_ALLOWED_LIMIT) : DEFAULT_TIME_LIMIT;

        const startTimer = () => {
          timerHandle = setTimeout(() => {
            const modelValue = "";

            controller.ngModel.$$rawModelValue = modelValue;
            controller.ngModel.$viewValue = modelValue;
            controller.ngModel.$commitViewValue();
            controller.ngModel.$render();

            timerHandle = null;
          }, TIME_LIMIT);
        };

        element.on("keypress", (event) => {
          if (timerHandle === null) {
            startTimer();
          }
        });
      }
    };
  }
];

export default AllowOnlyScanDirective;


// WEBPACK FOOTER //
// ./client/app/common/allow-only-scan/allow-only-scan.directive.js